var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useState } from 'react';
import NotificationsApi from '~/api/notifications';
import { useUser } from '~/providers/user';
const NotificationContext = createContext();
const NotificationProvider = props => {
    const { hasUserInfo } = useUser();
    const [notifications, setNotifications] = useState([]);
    const [loadingNotifications, setLoadingNotifications] = useState(false);
    const [updatingNotificationId, setUpdatingNotificationId] = useState();
    const markAsRead = (notificationId) => __awaiter(void 0, void 0, void 0, function* () {
        setUpdatingNotificationId(notificationId);
        const updatedNotification = yield NotificationsApi.update(notificationId, {
            isRead: true,
        });
        updatedNotification && updateNotifications(updatedNotification);
        setUpdatingNotificationId(undefined);
    });
    const markAsUnread = (notificationId) => __awaiter(void 0, void 0, void 0, function* () {
        setUpdatingNotificationId(notificationId);
        const updatedNotification = yield NotificationsApi.update(notificationId, {
            isRead: false,
        });
        updatedNotification && updateNotifications(updatedNotification);
        setUpdatingNotificationId(undefined);
    });
    const updateNotifications = (updatedNotification) => {
        const updatedNotifications = notifications.map(notification => {
            if (notification.id === updatedNotification.id) {
                notification.isRead = updatedNotification.isRead;
            }
            return notification;
        });
        setNotifications(updatedNotifications);
    };
    useEffect(() => {
        let pollingInterval;
        const getNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoadingNotifications(true);
            const newNotifications = yield NotificationsApi.get();
            setNotifications(newNotifications);
            setLoadingNotifications(false);
        });
        if (hasUserInfo) {
            getNotifications();
            pollingInterval = setInterval(getNotifications, 60 * 1000);
        }
        return () => {
            clearInterval(pollingInterval);
        };
    }, [hasUserInfo]);
    const value = {
        notifications,
        loadingNotifications,
        markAsRead,
        markAsUnread,
        updatingNotificationId,
    };
    return React.createElement(NotificationContext.Provider, Object.assign({ value: value }, props));
};
const useNotifications = () => {
    const ctx = useContext(NotificationContext);
    if (ctx === undefined) {
        throw new Error('NotificationContext only works inside of NotificationContext.Provider');
    }
    return ctx;
};
export { NotificationProvider, useNotifications, };
